export default __webpack_public_path__ + "static/media/amiba-observation.0c993ce3.jpg";